import { render, staticRenderFns } from "./marginBzjPage.vue?vue&type=template&id=f74f3eda&"
import script from "./marginBzjPage.vue?vue&type=script&lang=js&"
export * from "./marginBzjPage.vue?vue&type=script&lang=js&"
import style0 from "./marginBzjPage.vue?vue&type=style&index=0&id=f74f3eda&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports